function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import kebabCase from "../../lib/kebabCase";
function responsiveProps(cssObj, baseClass, key, value) {
  var kebabKey = kebabCase(key);
  Object.entries(value).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      breakpoint = _ref2[0],
      breakpointValue = _ref2[1];
    var suffix = typeof breakpointValue === 'boolean' ? '' : "-".concat(breakpointValue);
    var bpSuffix = breakpoint === 'xs' ? '' : "-".concat(breakpoint);
    cssObj["".concat(key, "-").concat(breakpoint)] = "".concat(baseClass).concat(kebabKey).concat(bpSuffix).concat(suffix);
  });
}
function propToCSS(cssObj, baseClass, key, value) {
  var kebabKey = kebabCase(key);
  if (typeof value === 'boolean') {
    cssObj[key] = "".concat(baseClass).concat(value ? '' : 'no-').concat(kebabKey);
    return;
  }
  if (key !== 'style' && value && _typeof(value) === 'object') {
    responsiveProps(cssObj, baseClass, key, value);
    return;
  }
  cssObj[key] = "".concat(baseClass).concat(kebabKey, "-").concat(value);
}
export default function compose(allProps) {
  var cssObj = {};
  var baseClass = 'u-';

  // Transform props to CSS
  Object.entries(allProps).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    if (value !== undefined) {
      propToCSS(cssObj, baseClass, key, value);
    }
  });
  var hasLayer = ('layer' in allProps);
  var hasAbsolute = ('absolute' in allProps);

  // Handle position based on props
  if (!('position' in cssObj)) {
    if (hasAbsolute) {
      cssObj.position = "".concat(baseClass, "position-absolute");
    } else if (hasLayer) {
      cssObj.position = "".concat(baseClass, "position-relative");
    }
  }

  // Cleanup
  if (hasAbsolute && 'position' in cssObj && typeof allProps.absolute === 'boolean') {
    delete cssObj.absolute;
  }
  return cssObj;
}